import { takeEvery } from 'redux-saga/effects';
import { clienSignSaga } from './clienSignSaga';
import { serverSignSaga } from './serverSignSaga';

import * as actionTypes from '../../../redux/sentToGp3/actions';

export default function* mainSignSaga() {
  yield takeEvery(actionTypes.SIGN_SERVER_REQUEST_START, serverSignSaga);
  yield takeEvery(actionTypes.SIGN_CLIENT_REQUEST_START, clienSignSaga);
}
